import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PlannerComponent } from '../../components/planner/planner.component';
import { ComponentType } from '@angular/cdk/portal';
import { SettingsComponent } from 'src/components/settings/settings.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  hasOpen = false;

  constructor(public matDialog: MatDialog) {}

  open<T>(
    component: ComponentType<T>,
    data?: any,
    panelClass?: string,
    disableClose?: boolean,
    afterClosed?: Function,
    minWidth?: string,
    minHeight?: string
  ) {
    if (this.hasOpen) return;

    this.hasOpen = true;
    const ref = this.matDialog.open(component, {
      data,
      panelClass,
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      disableClose,
      minWidth,
      minHeight,
    });

    ref.afterClosed().subscribe((data) => {
      this.hasOpen = false;
      if (afterClosed) afterClosed(data);
    });
  }

  openUpsell() {
    this.matDialog.closeAll();
    setTimeout(() => {
      this.open(
        SettingsComponent,
        { state: 'prefund_pro' },
        'settings-dialog',
        false,
        () => {},
        '800px',
        '650px'
      );
    }, 0);
  }
}
